import $axios from "../api/accessor";
import { $api } from "../api/api";

export const DangerousGoodsService = {
  async getAllDangerousGoods() {
    let response = await $axios
      .get($api("dangerous_goods"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
